<template>
  <div
    class="chat-window d-flex flex-column justify-content-between"
    :class="elClass"
    style="overflow-y: scroll;max-height: 100%;"
  >
    <div v-for="item in items">
      <div
        class="message-wrapper position-left"
        style="margin:0"
        :style="{'display':item.status == 1 ? 'none':'table'}"
      >
        <!---->
        <div class="group-layout row position-left" style="margin-left:0">
          <div class="col-b">
            <div class="base right">
              <div class="name text-ellipsis">{{ item.info.nickname }}</div>
              <input :data-id="item.info.username" type="hidden" class="user_id" />
            </div>
            <div class="content-wrapper justify-content-end">
              <div class style="width: 16px; height: 16px;">
                <input type="checkbox" name="onepass" :value="item" v-model="checkedNames" />
              </div>
              <div class="chat-bubble">
                <div class="el-dropdown">
                  <div
                    class="message-content message-send el-dropdown-selfdefine"
                    aria-haspopup="list"
                    aria-controls="dropdown-menu-4081"
                    role="button"
                    tabindex="0"
                  >{{ item.message }}</div>
                  <ul
                    class="el-dropdown-menu el-popper el-dropdown-menu--mini"
                    id="dropdown-menu-4081"
                    style="display: none;"
                  ></ul>
                </div>
                <!---->
              </div>
            </div>
          </div>
          <div class="col-c" style="position: relative;width:45px">
            <div style="position: absolute;bottom:0;">
              <div :id="'message'+item.id">
                <a
                  href="javascript:;"
                  title="点击通过审核"
                  @click="pass(item.id, item.info.username, item.message, item.room)"
                  class="btn btn-sm btn-success"
                  style="padding: 0.2rem 0.75rem;"
                >√</a>
                <a
                  href="javascript:;"
                  title="点击不通过审核"
                  @click="nopass(item.id)"
                  class="btn btn-sm btn-fail"
                  style="padding: 0.2rem 0.75rem;"
                >X</a>
              </div>
            </div>
          </div>
        </div>
        <!---->
      </div>
      <hr :style="{'display':item.status == 1 ? 'none':'flex'}" />
    </div>
    <!-- <vue-alert></vue-alert> -->
    <!-- <current-conversation /> -->
    <input type="button" value="批量审核" @click="onepass()" style="position: sticky;
    bottom: 0;" />
  </div>
</template>

<script>
import { ProfileService } from "../services/ProfileService";
import { translateGroupSystemNotice } from "./utils/common";
import { mapGetters, mapState } from "vuex";

export default {
  name: "ChatRoomExamine",

  components: {},

  computed: {},

  watch: {
    // notification(next) {
    //     this.$alert.show(next);
    // }
  },

  props: {
    elClass: {
      type: [String, Object]
    }
  },

  data() {
    return {
      items: {},
      messageContent: "",
      checkedNames: []
    };
  },
  computed: {
    ...mapGetters(["toAccount", "currentConversationType"]),
    ...mapState({
      memberList: state => state.group.currentMemberList,
      userID: state => state.user.userID
    })
  },
  mounted() {},
  created() {
    this.send();
    this.timer = setInterval(this.send, 60000);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    send() {
        var roomid = $("#roomid").val();
        console.log(roomid,11111)
        if(roomid){
        let axiosUrl = "/api/examine/get_message?roomid=" + roomid;
        axios
            .get(axiosUrl)
            .then(res => {
            this.items = res.data.datas;
            console.log(res.data.datas);
            })
            .catch(function(error) {
            console.log(error);
            });
        }

      //  setTimeout(
      //       this.send()
      //   , 2000)
    },
    pass(id, username, itemmessage, room) {
      let axiosUrl = "/api/examine/pass_message";
      // this.messageContent = itemmessage;
      let data = {
        id: id,
        username: username,
        itemmessage: itemmessage,
        room: room
      };
      axios
        .post(axiosUrl, data)
        .then(res => {
          this.items[id].status = 1;
          // console.log(res.data.code);
        })
        .catch(function(error) {
          // this.items[id].status = 1;
          alert("该用户已被禁言");
          console.log(error);
        });
      // const message = this.tim.createTextMessage({
      //     to: this.toAccount,
      //     conversationType: this.currentConversationType,
      //     payload: { text: this.messageContent }
      // })
      // this.$store.commit('pushCurrentMessageList', message)
      // this.$bus.$emit('scroll-bottom')
      // this.tim.sendMessage(message).catch(error => {
      //     this.$store.commit('showMessage', {
      //     type: 'error',
      //     message: error.message
      //     })
      // })
      // this.messageContent = ''
    },
    onepass() {
      let axiosUrl = "/api/examine/one_pass_message";
      let data = this.checkedNames;
      axios
        .post(axiosUrl, data)
        .then(res => {
          this.items = res.data.datas;
          // console.log(res.data.code);
        })
        .catch(function(error) {
          // this.items[id].status = 1;
          alert("该用户已被禁言");
          console.log(error);
        });
    },
    nopass(id){
      let axiosUrl = "/api/examine/no_pass_message";
      // this.messageContent = itemmessage;
      let data = {
        id: id
      };
      axios
        .post(axiosUrl, data)
        .then(res => {
          this.items[id].status = 1;
          // console.log(res.data.code);
        })
        .catch(function(error) {
          // this.items[id].status = 1;
          alert("网络异常，请稍后再试");
          console.log(error);

        });
    }
  }
};
</script>
